<template>
  <ValidationProvider v-slot="{ errors }" :name="label" :rules="rules">
    <b-field :type="{ 'is-danger': errors.length > 0 }" :message="errors[0]">
      <template slot="label">
        {{ label }}
        <!-- <sup v-if="rules && rules.includes('required')" class="has-text-danger"
          >(required)</sup
        > -->
        <b-tooltip
          v-if="tooltip"
          type="is-dark"
          :position="tooltipPosition"
          :label="tooltip"
          multilined
        >
          <b-icon size="is-small" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-select
        v-model="item"
        v-bind="$attrs"
        expanded
        v-on="$listeners"
        @input="
          $emit('input', item)
          $emit('change', item)
        "
      >
        <slot />
      </b-select>
    </b-field>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'BaseSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Object]
    },
    rules: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipPosition: {
      type: String,
      default: 'is-top'
    }
  },
  data() {
    return {
      item: this.value
    }
  },
  watch: {
    value() {
      this.item = this.value
    }
  }
}
</script>
